import { atom } from 'recoil'

const deletedItemAtom = atom<boolean>({
  key: 'deletedItem',
  default: false
})

export default deletedItemAtom
